import { Box } from '@chakra-ui/react'
import { EventCalendar } from '@src/components/sco/Events/EventCalendar'
import { EventsPage } from '@src/components/sco/Events/EventsLayout'
import { EventsMainPanel } from '@src/components/sco/Events/EventsLayout/EventsMainPanel.tsx'
import { EventsPageHeader } from '@src/components/sco/Events/EventsPageHeader'
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider'
import { useActiveContentContext } from '@src/contexts/ActiveContentContext'
import { useUniversalEffect } from '@src/hooks/useUniversalEffect'
import React from 'react'

export { getServerSideProps } from '@src/lib/server-side-rendering'

export default EventsPage(function Page() {
  const activeContent = useActiveContentContext()
  const { getBreakpointValue } = useBreakpointContext()

  useUniversalEffect(() => {
    activeContent.setSiteSection('events.landing')
    activeContent.setBreadcrumbs([
      {
        title: 'Events',
        href: '/events',
      },
      {
        title: 'Upcoming',
        href: '/events/upcoming',
      },
    ])
  })

  return (
    <EventsMainPanel>
      <Box
        marginX={'auto'}
        maxWidth={'1480px'}
        padding={getBreakpointValue(['1em', '1em', '2em'])}
        width={'full'}
      >
        <EventsPageHeader title={'Upcoming Events'} />
        <EventCalendar />
      </Box>
    </EventsMainPanel>
  )
})
